import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API
//
// The six German-speaking cities come first because they are the ones the
// kategorie pages name; Genf, Lausanne and Lugano follow so the Romandie and
// Ticino aren't left to type their way in from an empty dropdown.
//
// Bounds are the OpenStreetMap bounding boxes for each municipality, so several
// of them (Zug, Lausanne, Lugano) cover the wider commune rather than the
// centre. That is the useful shape here — a wider box returns more providers.
const defaultLocations = [
  {
    id: 'default-zurich',
    predictionPlace: {
      address: 'Zürich, Schweiz',
      bounds: new LatLngBounds(new LatLng(47.434665, 8.6254413), new LatLng(47.3202187, 8.4480061)),
    },
  },
  {
    id: 'default-bern',
    predictionPlace: {
      address: 'Bern, Schweiz',
      bounds: new LatLngBounds(
        new LatLng(46.9901535, 7.4955563),
        new LatLng(46.9190326, 7.2943145)
      ),
    },
  },
  {
    id: 'default-basel',
    predictionPlace: {
      address: 'Basel, Schweiz',
      bounds: new LatLngBounds(
        new LatLng(47.5898969, 7.6341484),
        new LatLng(47.5192971, 7.5546595)
      ),
    },
  },
  {
    id: 'default-luzern',
    predictionPlace: {
      address: 'Luzern, Schweiz',
      bounds: new LatLngBounds(new LatLng(47.083522, 8.4279853), new LatLng(46.9980047, 8.2065198)),
    },
  },
  {
    id: 'default-st-gallen',
    predictionPlace: {
      address: 'St. Gallen, Schweiz',
      bounds: new LatLngBounds(
        new LatLng(47.4530734, 9.4352474),
        new LatLng(47.3951549, 9.2915161)
      ),
    },
  },
  {
    id: 'default-zug',
    predictionPlace: {
      address: 'Zug, Schweiz',
      bounds: new LatLngBounds(
        new LatLng(47.2483746, 8.7011687),
        new LatLng(47.0810303, 8.3948456)
      ),
    },
  },
  {
    id: 'default-genf',
    predictionPlace: {
      address: 'Genf, Schweiz',
      bounds: new LatLngBounds(new LatLng(46.231885, 6.1758527), new LatLng(46.1777742, 6.1102411)),
    },
  },
  {
    id: 'default-lausanne',
    predictionPlace: {
      address: 'Lausanne, Schweiz',
      bounds: new LatLngBounds(new LatLng(46.6025814, 6.7208093), new LatLng(46.4548726, 6.583863)),
    },
  },
  {
    id: 'default-lugano',
    predictionPlace: {
      address: 'Lugano, Schweiz',
      bounds: new LatLngBounds(new LatLng(46.1191468, 9.0896151), new LatLng(45.939673, 8.8936571)),
    },
  },
];
export default defaultLocations;
